var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBranch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#6396ED",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.934 5.089h-7.05v1.804h7.05V25.83h-7.05v1.804h8.812V6.893c0-.997-.789-1.804-1.762-1.804z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M14.134.58H2.008C.976.58.139 1.436.139 2.492v25.142h15.863V2.492c0-1.056-.836-1.912-1.868-1.912zm.106 25.25h-2.644v-2.705h-7.05v2.705H1.902V2.492a.11.11 0 0 1 .03-.077.105.105 0 0 1 .076-.031h12.126c.058 0 .106.048.106.108V25.83z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.664 5.089h1.763v1.804H3.664zM7.19 5.089h1.762v1.804H7.19zM10.715 5.089h1.762v1.804h-1.762zM3.664 9.598h1.763v1.804H3.664zM7.19 9.598h1.762v1.804H7.19zM10.715 9.598h1.762v1.804h-1.762zM3.664 14.107h1.763v1.803H3.664zM7.19 14.107h1.762v1.803H7.19zM10.715 14.107h1.762v1.803h-1.762zM3.664 18.616h1.763v1.803H3.664zM7.19 18.616h1.762v1.803H7.19zM10.715 18.616h1.762v1.803h-1.762zM16.884 9.598h1.762v1.804h-1.762zM20.409 9.598h1.762v1.804H20.41zM16.884 14.107h1.762v1.803h-1.762zM20.409 14.107h1.762v1.803H20.41zM16.884 18.616h1.762v1.803h-1.762zM20.409 18.616h1.762v1.803H20.41z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranch);
export default __webpack_public_path__ + "static/media/branch.13fc23be5634f0750196a3cd9f2d0b89.svg";
export { ForwardRef as ReactComponent };